
export enum PgnShapeType {
    Polygon = "Polygon",
    Line = "Line",
    Circle = "Circle",
    Square = "Square",
    Text = "Text"
}
